module.exports = __webpack_public_path__ + "media/assets/images/landing/Group 29-ae818448f5a25091a164b629ed7b86ad.png";